import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.42822 9.32971L1.61164 17.5198C1.49353 17.6518 1.42822 17.8228 1.42822 18C1.42822 18.1772 1.49353 18.3481 1.61164 18.4802L9.42822 26.6702",
  stroke: "#121926",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M26.5728 9.32971L34.3893 17.5198C34.5075 17.6518 34.5728 17.8228 34.5728 18C34.5728 18.1772 34.5075 18.3481 34.3893 18.4802L26.5728 26.6703",
  stroke: "#121926",
  "stroke-width": "2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 17.9885L11 17.9885",
  stroke: "#121926",
  "stroke-width": "2"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M25 17.9885L20 17.9885",
  stroke: "#121926",
  "stroke-width": "2"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }